import { createEntityDeps } from '@st/use/composables'

export interface BookmakerDeps {
  hasOutcome: (uniqId: string) => boolean
}

const [useBookmakerDeps, provideBookmakerDeps] =
  createEntityDeps<BookmakerDeps>('bookmaker')

export { useBookmakerDeps, provideBookmakerDeps }
